"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarPicker = void 0;
var React = require("react");
var avatars_1 = require("../Avatar/avatars");
var AvatarPickerItem_1 = require("./AvatarPickerItem");
require("./AvatarPicker.scss");
var AvatarPicker = function (props) {
    var selectedAvatar = props.selectedAvatar, onAvatarPicked = props.onAvatarPicked;
    return (React.createElement("div", { className: "avatar-selection-container" },
        React.createElement("div", { className: "avatar-icons" }, avatars_1.avatars.map(function (avatar) { return (React.createElement(AvatarPickerItem_1.AvatarPickerItem, { key: avatar, avatar: avatar, isSelected: selectedAvatar === avatar, onClick: function () { return onAvatarPicked(avatar); } })); }))));
};
exports.AvatarPicker = AvatarPicker;
